import { render, staticRenderFns } from "./EditSpecificQualityParameter.vue?vue&type=template&id=0b388fa7"
import script from "./EditSpecificQualityParameter.vue?vue&type=script&lang=js"
export * from "./EditSpecificQualityParameter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports